// extracted by mini-css-extract-plugin
module.exports = {"content":"StandContent-content-0a07"};